import { render } from "./RegisterUsers.vue?vue&type=template&id=7398d6b7&scoped=true"
import script from "./RegisterUsers.vue?vue&type=script&lang=js"
export * from "./RegisterUsers.vue?vue&type=script&lang=js"

import "./RegisterUsers.vue?vue&type=style&index=0&id=7398d6b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7398d6b7"]])

export default __exports__